import React from "react";
import style from "../pages/login/login.module.css";

type Props = {
  title: string;
  placeholder: string;
  isIcon?: boolean;
  icon?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  type?: string;
  value?: string;
  ref?: React.LegacyRef<HTMLInputElement> | undefined
  isRequired?: boolean
  name?: string
};

const Input = ({
  title,
  placeholder,
  isIcon = false,
  icon = "fa fa-phone",
  onChange,
  onClick,
  type = "text",
  value,
  isRequired = false,
  name = ''
}: Props) => {
  return (
    <div className={style.loginMobileNumber}>
      {title}
      {isRequired && <span className="text-red-500">{' *'}</span>}
      <div className={style.inputContainer}>
        <input type={type} name={name} placeholder={placeholder} value={value} onChange={(e)=> {onChange && onChange(e)}}  />
        {isIcon && <i className={icon} onClick={(e)=> {onClick && onClick(e)}}></i>} {/* Use "fa" instead of "fas" */}
      </div>
    </div>
  );
};

export default Input;
